import { render, staticRenderFns } from "./orderCustomizeDetails.vue?vue&type=template&id=c3a35d66&scoped=true"
import script from "./orderCustomizeDetails.vue?vue&type=script&lang=js"
export * from "./orderCustomizeDetails.vue?vue&type=script&lang=js"
import style0 from "./orderCustomizeDetails.vue?vue&type=style&index=0&id=c3a35d66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a35d66",
  null
  
)

export default component.exports